// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const SelectLensToUpdateHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensForUpdate.lensSpace.selectLensToUpdateHeader"
        description="Select lens to update header."
        defaultMessage="Select a Lens to Update"
    />
);
SelectLensToUpdateHeader.displayName = "SelectLensToUpdateHeader";

export const SelectLensToUpdateSubHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensForUpdate.lensSpace.selectLensToUpdateSubHeader"
        description="Select lens to update sub header."
        defaultMessage="You are updating an existing Lens. The current version will be replaced."
    />
);
SelectLensToUpdateSubHeader.displayName = "SelectLensToUpdateSubHeader";
